import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { MercadoSituacaoModule } from '../../../mercado/situacao';
import { UnidadeNegocioMercadoModule } from '../../../unidade-negocio/mercado';
import { NaturezaVendaSituacaoModule } from '../../../natureza-venda/situacao';
import { UnidadeNegocioNaturezaVendaModule } from '../../../unidade-negocio/natureza-venda';

import { ClienteUnidadeNegocio2Component } from './cliente-unidade-negocio2.component';
import { ClienteUnidadeNegocioMercadoComponent, ClienteUnidadeNegocioMercadoSituacaoFilterPipe } from './mercado';
import { ClientUnidadeNegocioNaturezaVendaComponent, ClienteUnidadeNegocioNaturezaVendaSituacaoFilterPipe } from './natureza-venda';
import { ClienteUnidadeNegocioItemTipoComponent, ClienteUnidadeNegocioItemTipoSituacaoFilterPipe } from './item-tipo';
import { ClienteUnidadeNegocioInsertModalComponent } from './insert';

@NgModule({
    imports: [
        SharedModule,
        MercadoSituacaoModule,
        UnidadeNegocioMercadoModule,
        NaturezaVendaSituacaoModule,
        UnidadeNegocioNaturezaVendaModule
    ],
    declarations: [
        ClienteUnidadeNegocio2Component,
        ClienteUnidadeNegocioMercadoComponent,
        ClienteUnidadeNegocioMercadoSituacaoFilterPipe,
        ClientUnidadeNegocioNaturezaVendaComponent,
        ClienteUnidadeNegocioNaturezaVendaSituacaoFilterPipe,
        ClienteUnidadeNegocioItemTipoSituacaoFilterPipe,
        ClienteUnidadeNegocioItemTipoComponent,
        ClienteUnidadeNegocioInsertModalComponent
    ],
    exports: [
        ClienteUnidadeNegocio2Component,
        ClienteUnidadeNegocioMercadoComponent,
        ClienteUnidadeNegocioMercadoSituacaoFilterPipe,
        ClientUnidadeNegocioNaturezaVendaComponent,
        ClienteUnidadeNegocioNaturezaVendaSituacaoFilterPipe,
        ClienteUnidadeNegocioItemTipoSituacaoFilterPipe,
        ClienteUnidadeNegocioItemTipoComponent,
        ClienteUnidadeNegocioInsertModalComponent
    ],
    providers: [
        ClienteUnidadeNegocioMercadoSituacaoFilterPipe,
        ClienteUnidadeNegocioNaturezaVendaSituacaoFilterPipe,
        ClienteUnidadeNegocioItemTipoSituacaoFilterPipe
    ]
})
export class ClienteUnidadeNegocio2Module { }
